import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { fetchData, postData } from '../../../apiService';
import { IconButton } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import Button from '@mui/material/Button';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Select from 'react-select';
import Paper from '@mui/material/Paper';
import { Tooltip } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Link } from 'react-router-dom';
import Modal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';




const Extraloading = () => {
  const { id } = useParams();

  const history = useHistory();
  const { isAuthenticated, companyId, userId, token, logout } = useAuth();

  useEffect(() => {
    if (isAuthenticated && tokenIsExpired(token)) {
      logout();
    }
  }, [isAuthenticated, token, logout]);

  const [rate, setRate] = useState('');
  const [discount, setDiscount] = useState('');
  const [singlediscount, setsingleDiscount] = useState('');
  const [GSTRate, setGSTRate] = useState('');
  const [Data, setData] = useState([]);
  const [customerId, setCustomerId] = useState('');
  const [qty, setQty] = useState('');
  const [SaleRemarks, setSaleRemarks] = useState("");
  const [Bundle, setBundle] = useState('');
  const [pricetype, setpricetype] = useState('');
  const [orderDate, setOrderDate] = useState('');
  const [Route, setRoute] = useState("");
  const [routeId, setrouteId] = useState("");

  useEffect(() => {
    fetchtableData();
  }, []);

  const fetchtableData = async () => {
    try {
      const response = await fetchData('RoutePriceTypeApi', `/${id}`, token);

      if (response.responseCode === '1111') {
        setData(response.response_data);

        const Route = response.response_data[0].name;
        const pricetype = response.response_data[0].pricetype;
        const routeId = response.response_data[0].id; // Retrieve routeId
        const orderDate = response.response_data[0].orderDate;

        setpricetype(pricetype);
        setRoute(Route);
        setOrderDate(orderDate);
        setrouteId(routeId);
        console.log(response);

      }
    } catch (error) {
      console.error('Error fetching Item Details:', error);
      if (error.response && error.response.status === 401) {
        logout();
      }
    }
  };


  const [categoryId, setCategoryId] = useState('');
  const [productCategoryId, setPCategoryId] = useState('');
  const [itemId, setItemId] = useState('');
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [pcategoryOptions, setPCategoryOptions] = useState([]);
  const [itemOptions, setItemOptions] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedPCategory, setSelectedPCategory] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);

  //Product catgory
  useEffect(() => {
    const fetchPCategoryTypes = async () => {
      try {
        const response = await fetchData('ProductCategoryApi', `/${companyId}`, token);

        if (response.responseCode === '1111') {
          const dataArray = response.response_data;
          const options = response.response_data.map(pcat => ({
            value: pcat.id,
            label: pcat.name
          }));
          setPCategoryOptions(options);
          setPCategoryId(dataArray[0].id);
        }
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    };

    fetchPCategoryTypes();
  }, [companyId, token]);

  const handlePCategoryChange = (selectedOption) => {
    setSelectedPCategory(selectedOption);
    fetchItemsTypes(selectedOption.value);
    setPCategoryId(selectedOption.value);
    setSelectedItem(null);
  };


  //catgory
  useEffect(() => {
    const fetchCategoryTypes = async () => {
      try {
        const response = await fetchData('CategoryApi', `/${companyId}/${productCategoryId}`, token);
        if (response.responseCode === '1111') {
          const options = response.response_data.map(cat => ({
            value: cat.id,
            label: cat.name
          }));
          setCategoryOptions(options);
        }
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    };

    fetchCategoryTypes();
  }, [companyId, productCategoryId, token]);

  const handleCategoryChange = (selectedOption) => {
    setSelectedCategory(selectedOption);
    fetchItemsTypes(selectedOption.value);
    setCategoryId(selectedOption.value);
    setSelectedItem(null);
  };

  const fetchItemsTypes = async (categoryId) => {
    try {
      const response = await fetchData('ItemApi', `/${companyId}/${categoryId}`, token);
      if (response.responseCode === '1111') {
        const options = response.response_data.map(item => ({
          value: item.id,
          label: item.name
        }));
        setItemOptions(options);
      }
    } catch (error) {
      console.error('Error fetching items:', error);
    }
  };

  const [QtyBundle, setQtyBundle] = useState('');

  const handleItemChange = async (selectedOptions) => {
    setSelectedItem(selectedOptions);
    const ItemID = selectedOptions.value;
    setItemId(ItemID);

    try {
      const response = await fetchData('RoutePriceTypeApi', `/${routeId}/${ItemID}`, token);

      if (response && response.response_data && response.response_data.length > 0) {
        let itemFound = false;

        // Iterate through each category in response_data
        response.response_data.forEach(category => {
          if (category.Items && category.Items.length > 0) {
            category.Items.forEach(item => {
              if (!itemFound) {
                console.log(`Processing item: ${item.Name}`);
                // Process each item here
                // Extract numeric part from Weight

                const { Rate, GSTRate, Weight, Bundle, QtyBundle } = item;
                const numericWeight = parseFloat(Weight);
                setRate(Rate);
                setGSTRate(GSTRate);
                setBundle(Bundle);
                setQtyBundle(QtyBundle);
                setNewItem((prevItem) => ({
                  ...prevItem,
                  weight: numericWeight, // Add weight to the newItem state
                  rate: Rate,
                  GSTRate: GSTRate,
                  //Bundle: Bundle,
                  Bundle: Bundle ?? 0, // Set Bundle to 0 if it's null
                  QtyBundle: QtyBundle ?? 0,
                }));
                itemFound = true; // Set itemFound to true when an item is processed
              }
            });
          }
        });

        if (!itemFound) {
          console.error('No items found in the response data');
        }
      } else {
        console.error('Invalid response structure');
      }
    } catch (error) {
      console.error('Error fetching item rate:', error);
    }
  };


  const [newItem, setNewItem] = useState("");



  const handleQtyChange = (e) => {
    const input = e.target.value.replace(/\D/g, ''); // Remove non-digit characters
    if (input.length <= 10) { // Limit input length to avoid overflow
      setQty(input); // Update state with cleaned input

      const quantity = parseInt(input) || 0; // Parse input to integer, default to 0 if NaN
      // Calculate other derived values based on your logic
      const gstAmount = (rate * GSTRate) / 100;
      const totalAmount = rate * quantity;
      const totalPlusGst = totalAmount + gstAmount;
      const totalQuantity = newItem.weight * quantity;

      // Update state with the new calculated values
      setNewItem((prevItem) => ({
        ...prevItem,
        quantity: quantity,
        totalAmount: totalAmount,
        GSTRate: GSTRate,
        gstAmount: gstAmount,
        totalPlusGst: totalPlusGst,

        discount: discount,
        totalQuantity: totalQuantity,
      }));
    }
  };



  useEffect(() => {
    const quantity = parseInt(qty) || 0;
    const gstAmount = (rate * GSTRate) / 100;
    const totalAmount = rate * quantity;
    const totalPlusGst = totalAmount + gstAmount;
    const bundle = Bundle;
    //const pieceCount = quantity % newItem.Bundle;
    setNewItem((prevItem) => ({
      ...prevItem,
      rate: rate,
      totalAmount: totalAmount,
      gstAmount: gstAmount,
      totalPlusGst: totalPlusGst,
      discount: discount, // Ensure correct reference
      Bundle: bundle,
      //pieces: pieceCount,
    }));
  }, [rate, qty, discount, GSTRate, Bundle]); // Added dependencies

  const [itemList, setItemList] = useState([]);


  const AddtoListdata = (e) => {
    e.preventDefault();

    const quantity = parseInt(qty);
    //const bundleSize = parseInt(newItem.Bundle);
    const bundleSize = parseInt(newItem.Bundle) || 0; // Default to 1 if Bundle is null or 0

    // Calculate number of bundles and remaining pieces
    // Check if bundleSize is valid (not null or 0)
    const numBundles = bundleSize ? Math.floor(quantity / bundleSize) : 0;
    const pieceCount = bundleSize ? quantity % bundleSize : 0;


    // existing calculations
    const rateperkg = rate;
    const totalQuantity = newItem.weight * quantity;
    const totalAmount = rate * quantity;
    const TotalAmtperkgwise = rateperkg * totalQuantity;
    const TaxableAmount = ((rateperkg - discount) * totalQuantity * 100) / (100 + GSTRate);
    const gstAmount = (TaxableAmount * GSTRate) / 100;
    const GstPer = (gstAmount / TaxableAmount) * 100;
    const totalPlusGst = TaxableAmount + gstAmount;

    const updatedItem = {
      ...newItem,
      Name: selectedItem.label,
      Id: selectedItem.value,
      quantity: quantity,
      rate: rate,
      GSTRate: GSTRate,
      totalAmount: totalAmount,
      totalPlusGst: totalPlusGst,
      discount: discount,
      totalQuantity: totalQuantity,
      rateperkg: rateperkg,
      TotalAmtperkgwise: TotalAmtperkgwise,
      TaxableAmount: TaxableAmount,
      gstAmount: gstAmount,
      GstPer: GstPer,
      Bundle: numBundles,
      Pieces: pieceCount,
      QtyBundle: QtyBundle,
    };

    // Updating state
    setItemList([...itemList, updatedItem]);

    // Resetting newItem state
    setNewItem({
      Id: '',
      Name: '',
      quantity: 1,
      GSTRate: 0,
      rate: 0,
      totalAmount: 0,
      totalPlusGst: 0,
      discount: 0,
      weight: 0,
      totalQuantity: 0,
      rateperkg: 0,
      TotalAmtperkgwise: 0,
      GstPer: 0,
      gstAmount: 0,
      TaxableAmount: 0,
      Bundle: 0,
      pieces: 0,
    });

    // Resetting other state variables
    setSelectedItem('');
    setQty('');
    setRate('');
    setGSTRate(0);
    setBundle('');
  };


  const handleDiscountChange = (e, index) => {
    const value = parseFloat(e.target.value) || 0;
    const updatedItems = [...itemList];
    updatedItems[index].singlediscount = value;
    const TotalQuantity = updatedItems[index].totalQuantity;
    const rateperkg = updatedItems[index].rateperkg;
    const totalAmount = updatedItems[index].rate * updatedItems[index].quantity;
    const TotalAmtperkgwise = rateperkg * TotalQuantity;
    const TaxableAmount = (((rateperkg - value) * TotalQuantity * 100) / (100 + updatedItems[index].GSTRate));
    // const gstAmount = (totalAmount * updatedItems[index].GSTRate) / 100;
    const gstAmount = (TaxableAmount * updatedItems[index].GSTRate) / 100;
    const GstPer = (gstAmount / TaxableAmount) * 100;
    const totalPlusGst = TaxableAmount + gstAmount;

    updatedItems[index].totalPlusGst = totalPlusGst;
    updatedItems[index].discount = value;
    updatedItems[index].gstAmount = gstAmount;
    updatedItems[index].GstPer = GstPer;
    updatedItems[index].TaxableAmount = TaxableAmount;
    setItemList(updatedItems);
  };


  //qty edit
  // const handleQuantityChange = (e, index) => {
  //   const { value } = e.target;
  //   const updatedItems = [...itemList];
  //   updatedItems[index].quantity = parseInt(value, 10);
  //   let bundleSize = 0;// Default to 1 if Bundle is null or 0

  //   const DiscountPerPiece = updatedItems[index].DiscountPerPiece || 0;
  //   const bag = updatedItems[index].BagWeight || 0;
  //   const bagweight = updatedItems[index].weight || 0;
  //   let BagWeight = 0;
  //   if (bag > 0) { //exixting
  //     BagWeight = bag;
  //     bundleSize = parseInt(updatedItems[index].BundleAndPiece) || 0;
  //   }
  //   else if (bagweight > 0) {
  //     BagWeight = bagweight;
  //     bundleSize = parseInt(updatedItems[index].QtyBundle) || 0;

  //   }
  //   const numBundles = bundleSize ? Math.floor(value / bundleSize) : 0;
  //   const pieceCount = bundleSize ? value % bundleSize : 0;
  //   const TotalQty = BagWeight * value;
  //   const rateperkg = updatedItems[index].RatePerKg;
  //   const RateAfterDiscount = rateperkg - DiscountPerPiece;
  //   const totalAmount = updatedItems[index].rate * updatedItems[index].quantity;
  //   const TotalAmtperkgwise = RateAfterDiscount * TotalQty;
  //   const TaxableAmt = (((RateAfterDiscount) * TotalQty * 100) / (100 + updatedItems[index].GSTRate));
  //   // const gstAmount = (totalAmount * updatedItems[index].GSTRate) / 100;
  //   const GSTAmt = (TaxableAmt * updatedItems[index].GSTRate) / 100;
  //   const GSTRate = updatedItems[index].GSTRate;
  //   const GstPer = (GSTAmt / TaxableAmt) * 100;
  //   const NetAmt = TaxableAmt + GSTAmt;
  //   updatedItems[index].RateAfterDiscount = RateAfterDiscount;
  //   updatedItems[index].GSTAmt = GSTAmt;
  //   updatedItems[index].NetAmt = NetAmt;
  //   updatedItems[index].DiscountPerPiece = DiscountPerPiece;
  //   updatedItems[index].TotalQty = TotalQty;
  //   updatedItems[index].GSTRate = GSTRate;
  //   updatedItems[index].TaxableAmt = TaxableAmt;
  //   updatedItems[index].Bundle = numBundles;
  //   updatedItems[index].Pieces = pieceCount;
  //   setItemList(updatedItems);
  // };


  const handleQuantityChange = (e, index) => {
    const { value } = e.target;
    const updatedItems = [...itemList];
    const quantity = parseInt(value, 10);
    updatedItems[index].quantity = quantity;

    let bundleSize = 0;
    const DiscountPerPiece = updatedItems[index].DiscountPerPiece || 0;
    const bag = updatedItems[index].BagWeight || 0;
    const bagweight = updatedItems[index].weight || 0;
    let BagWeight = 0;

    if (bag > 0) {
        BagWeight = bag;
        bundleSize = parseInt(updatedItems[index].BundleAndPiece) || 0;
    } else if (bagweight > 0) {
        BagWeight = bagweight;
        bundleSize = parseInt(updatedItems[index].QtyBundle) || 0;
    }

    const rateperkg = updatedItems[index].rateperkg || 0;

    const numBundles = bundleSize ? Math.floor(quantity / bundleSize) : 0;
    const pieceCount = bundleSize ? quantity % bundleSize : 0;
      // Calculate Total Quantity (Kgs)
    const TotalQuantity = BagWeight * quantity;
    updatedItems[index].totalQuantity = TotalQuantity;

    const RateAfterDiscount = rateperkg - DiscountPerPiece;
    updatedItems[index].RateAfterDiscount = RateAfterDiscount;

    const TaxableAmount = ((RateAfterDiscount * TotalQuantity * 100) / (100 + updatedItems[index].GSTRate)) || 0;
    updatedItems[index].TaxableAmount = TaxableAmount;

    const gstAmount = (TaxableAmount * updatedItems[index].GSTRate / 100) || 0;
    updatedItems[index].gstAmount = gstAmount;

    const totalPlusGst = TaxableAmount + gstAmount;
    updatedItems[index].totalPlusGst = totalPlusGst;

    const totalAmount = RateAfterDiscount * quantity;
    updatedItems[index].totalAmount = totalAmount;

    updatedItems[index].Bundle = numBundles;
    updatedItems[index].Pieces = pieceCount;

    console.log("Updated Item:", updatedItems[index]); // Debug log to check updated values
    
    setItemList(updatedItems); // This should trigger a re-render with the updated state
};



  const submitData = async (e) => {
    e.preventDefault();
    try {
      const itemsToSave = itemList.map(item => ({
        ItemId: item.Id,
        CustomerId: customerId || 0, // Ensure CustomerId is set to 0 if not provided
        CompanyId: companyId,
        CategoryId: categoryId,
        ProductCategoryId: productCategoryId,
        //rate: item.Rate,
        rate: item.rate,
        Quantity: item.quantity,
        Discount: item.discount ? item.discount : 0,
        BilledDate: new Date(),
        CreatedBy: userId,
        CreatedDate: new Date(),
        RatePerKg: item.rateperkg,
        DiscountPerPiece: item.singlediscount ? item.singlediscount : 0,
        //RateAfterDiscount: (item.rateperkg - item.singlediscount),
        RateAfterDiscount: (item.rateperkg || 0) - (item.singlediscount || 0),
        TotalQty: item.totalQuantity,
        BagWeight: item.weight,
        CGSTAmt: (item.gstAmount / 2),
        SGSTAmt: (item.gstAmount / 2),
        GSTAmt: item.gstAmount,
        TaxableAmt: item.TaxableAmount,
        NetAmt: item.totalPlusGst,
        Bundle: item.Bundle,
        Pieces: item.Pieces

      }));

      const saleorderdata = {
        TripId: id,
        CustomerId: customerId || 0, // Ensure CustomerId is set to 0 if not provided
        OrderDate: orderDate,
        SaleRemarks: SaleRemarks,
        CreatedBy: userId,
        CompanyId: companyId,
        CreatedDate: new Date(),
        OrderType: 3,
      };

      const CreateData = {
        SaleOrder: saleorderdata,
        SaleOrderDetails: itemsToSave,
      };

      // Show a confirmation dialog before submitting the order
      const confirmOrder = window.confirm('Are you sure you want to confirm the order?');
      if (confirmOrder) {
        postData('RoutePriceTypeApi', CreateData, token)
          .then((response) => {
            if (response.response === '1111') {
              const SaleOrderid = response.SaleOrderId;
              history.push(`/TriporderedIndexs/${id}`);
            }
          })
          .catch((error) => {
            console.error('SaleOrder Create error:', error);
          });
      }
    } catch (error) {
      console.error('Submit error:', error);
    }
  };

  const [itemToDeleteIndex, setItemToDeleteIndex] = useState(null);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

  const openConfirmDialog = (index) => {
    setItemToDeleteIndex(index);
    setConfirmDialogOpen(true);
  };

  const closeConfirmDialog = () => {
    setConfirmDialogOpen(false);
    setItemToDeleteIndex(null);

  };

  const handleDelete = () => {
    if (itemToDeleteIndex !== null) {
      const updatedItemList = itemList.filter((_, i) => i !== itemToDeleteIndex);
      setItemList(updatedItemList);
      closeConfirmDialog();
    }
  };


  const [showModal, setShowModal] = useState(false);
  const [filteredData, setFilteredData] = useState([]);



  const opendatamodal = () => {
    handleHistoryClick(id);

    setShowModal(true);
  };


  const handleHistoryClick = async (id) => {
    try {
      const response = await fetchData('OrderSummaryApi', `/${companyId}/${id}`, token);
      if (response.responseCode === '1111') {
        setFilteredData(response.response_data);
        setShowModal(true);
        // console.log('Modal state set to true:', showModal);
      } else {
        console.error('Invalid response code:', response.responseCode);
      }
    } catch (error) {
      console.error('Error fetching Order Items:', error);
    }
  };



  const closeModal = () => {
    console.log('Closing modal');
    setShowModal(false);
  };

  return (
    <div style={{ maxWidth: '100%', backgroundColor: '#f0f7f4', padding: '16px', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)' }}>
      <div style={{ backgroundColor: 'white', padding: '16px', borderRadius: '8px' }}>
        <form onSubmit={submitData}>
          
          {/* Header Section */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', paddingBottom: '12px', borderBottom: '2px solid #6b4c7a' }}>
            <div>
              <h2 style={{ margin: 0, fontSize: '18px', fontWeight: 'bold', color: '#6b4c7a', fontFamily: 'Arial, sans-serif', textTransform: 'uppercase' }}>
                Extra Loading
              </h2>
              <div style={{ display: 'flex', gap: '20px', marginTop: '8px', fontSize: '13px', color: '#2c3e50' }}>
                <span><strong>Route:</strong> {Route}</span>
                <span><strong>Order Date:</strong> {orderDate && new Date(orderDate).toLocaleDateString('en-GB')}</span>
                <span><strong>Price Type:</strong> {pricetype}</span>
              </div>
            </div>
            <div style={{ display: 'flex', gap: '8px' }}>
              <Button 
                variant="contained" 
                type="submit" 
                style={{ 
                  minWidth: '120px', 
                  height: '36px', 
                  fontSize: '12px', 
                  backgroundColor: '#10a37f', 
                  color: 'white',
                  fontWeight: 'bold',
                  borderRadius: '18px',
                  textTransform: 'none'
                }}
              >
                Order Confirm
              </Button>
              <Button
                variant="contained"
                color="error"
                component={Link}
                to={`/TriporderedIndexs/${id}`}
                style={{ 
                  height: '36px',
                  fontSize: '12px',
                  borderRadius: '18px',
                  textTransform: 'none'
                }}
              >
                Cancel
              </Button>
            </div>
          </div>

          {/* Remarks Input */}
          <div style={{ marginBottom: '16px' }}>
            <input 
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
              value={SaleRemarks} 
              onChange={(e) => setSaleRemarks(e.target.value)} 
              type="text" 
              placeholder="Enter Remarks Here"
              style={{ fontSize: '13px' }}
            />
          </div>           <br />
          <div className="w-full mb-4 flex" style={{ marginTop: '-35px' }}>
            <div className="w-2/4 mr-2">
              <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="code" style={{ fontSize: '15px' }}>
                Category
              </label>
              <Select
                value={selectedPCategory}
                onChange={handlePCategoryChange}
                options={pcategoryOptions}
                placeholder="Select Category"
                isSearchable

              />
            </div>
            <div className="w-2/4 mr-2">
              <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="code" style={{ fontSize: '15px', width: '200px' }}>
                Variant
              </label>
              <Select
                value={selectedCategory}
                onChange={handleCategoryChange}
                options={categoryOptions}
                placeholder="Select Category"
                isSearchable

              />
            </div>

            <div className="w-2/4 mr-2">
              <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="code" style={{ fontSize: '15px' }}>
                Variant with Bagweight
              </label>
              <Select
                value={selectedItem}
                onChange={handleItemChange}
                options={itemOptions}
                placeholder="Select Item"
                isSearchable

              />
            </div>
            <div className="w-1/8 mr-2" >
              <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="Quantity" style={{ fontSize: '15px' }}>
                QTY (No.of pieces)

              </label>
              <input
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                value={qty}
                onChange={handleQtyChange}
                type="text"
                placeholder="Quantity"
                style={{ width: '150px', height: '37px' }}
              />
            </div>
            <div className="w-1/6 mr-2">
              <Button variant="contained" color="primary" onClick={AddtoListdata} style={{ marginTop: '32px', marginLeft: '5px', fontSize: '12px' }}>Add Item</Button>
            </div>

          </div>



          {/* <div className="bg-tabcolor rounded-lg shadow-lg p-6" style={{ marginTop: '20px', backgroundColor: 'rgba(255, 255, 255, 0.5)', maxHeight: '400px', overflowY: 'auto' }}> */}

          <div className="w-full mb-4 flex" style={{ marginTop: '-20px', maxWidth: '110%' }}>
            <div className="w-full mb-4 flex">
              <TableContainer component={Paper}>
                <table className="table">
                  <thead style={{ backgroundColor: '#6b4c7a', color: 'white' }}>
                    <tr>
                      <th className="px-4 py-2 text-left text-sm font-medium" style={{ width: '1%', fontSize: '11px', padding: '6px', textAlign: 'left', color: 'white' }}>Sl.No</th>
                      <th className="px-4 py-2 text-left text-sm font-medium" style={{ width: '17%', fontSize: '11px', padding: '6px', color: 'white' }}>Name</th>
                      <th className="px-4 py-2 text-right text-sm font-medium" style={{ fontSize: '11px', padding: '6px', color: 'white' }}>Qty
                        <p style={{ fontSize: '10px', marginBottom: '-10px' }}>(No.Pieces)</p>
                      </th>
                      <th className="px-4 py-2 text-right text-sm font-medium" style={{ textAlign: 'left', width: '12%', fontSize: '11px', padding: '6px', color: 'white' }}>Total Qty
                        <p style={{ fontSize: '10px', marginBottom: '-10px' }}>(Kgs)</p>
                      </th>
                      <th className="px-4 py-2 text-right text-sm font-medium" style={{ textAlign: 'center', width: '2%', fontSize: '11px', padding: '6px', color: 'white' }}>Bundle</th>
                      <th className="px-4 py-2 text-right text-sm font-medium" style={{ textAlign: 'center', width: '2%', fontSize: '11px', padding: '6px', color: 'white' }}>Pieces</th>
                      <th className="px-4 py-2 text-right text-sm font-medium" style={{ width: '13%', fontSize: '11px', padding: '6px', color: 'white' }}>Rate/Kg
                        <p style={{ fontSize: '10px', marginBottom: '-10px' }}>(Including Tax)</p>
                      </th>
                      <th className="px-4 py-2 text-right text-sm font-medium" style={{ width: '3%', fontSize: '11px', padding: '6px', color: 'white' }}>Discount</th>
                      <th className="px-4 py-2 text-right text-sm font-medium" style={{ textAlign: 'center', width: '14%', fontSize: '11px', padding: '6px', color: 'white' }}>Rate
                        <p style={{ fontSize: '9.5px', marginBottom: '-10px' }}>(After Discount)</p>
                      </th>
                      <th className="px-4 py-2 text-right text-sm font-medium" style={{ width: '12%', textAlign: 'left', fontSize: '11px', padding: '6px', color: 'white' }}>Taxable Amt </th>
                      <th className="px-4 py-2 text-right text-sm font-medium" style={{ width: '3%', textAlign: 'left', fontSize: '11px', padding: '6px', color: 'white' }}>GST%</th>
                      <th className="px-4 py-2 text-right text-sm font-medium" style={{ width: '13%', fontSize: '11px', padding: '6px', color: 'white' }}>
                        GST (₹)
                      </th>
                      <th className="px-4 py-2 text-right text-sm font-medium" style={{ width: '13%', fontSize: '11px', padding: '6px', color: 'white' }}>Total</th>
                    </tr>
                  </thead>

                  <tbody>
                    {itemList.map((item, index) => (
                      <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#f8f9fa' : 'white' }}>
                        <td className="px-4 py-2 border-r text-left text-sm" style={{ width: '1%', fontSize: '11px', padding: '6px', color: '#2c3e50' }}>{index + 1}</td>
                        <td className="px-4 py-2 border-r text-left text-sm" style={{ width: '15%', fontWeight: 'bold', fontSize: '11px', padding: '6px', color: '#2c3e50' }}>{item.Name}</td>
                         <td className="px-4 py-2 border-r text-right text-sm" style={{ fontSize: '11px', padding: '6px', color: '#2c3e50' }}>{item.quantity}</td> 
                        {/* <td className="px-4 py-2 border-r text-right text-sm">
                          <input
                            type="number"
                            value={item.quantity}
                            onChange={(e) => handleQuantityChange(e, index)}
                            style={{ maxWidth: '120px', textAlign: 'right' }}

                            min="0"
                            step="1"
                          />
                        </td> */}
                        <td className="px-4 py-2 border-r text-right text-sm" style={{ fontSize: '11px', padding: '6px', color: '#2c3e50' }}>{item.totalQuantity}</td>
                        <td className="px-4 py-2 border-r text-right text-sm" style={{ fontSize: '11px', padding: '6px', color: '#2c3e50' }}>{item.Bundle}</td>
                        <td className="px-4 py-2 border-r text-right text-sm" style={{ fontSize: '11px', padding: '6px', color: '#2c3e50' }}>{item.Pieces}</td>
                        <td className="px-4 py-2 border-r text-right text-sm" style={{ fontSize: '11px', padding: '6px', color: '#2c3e50' }}>
                          {Number(item.rateperkg).toFixed(2)}
                        </td>



                        <td className="px-4 py-2 border-r text-right text-sm" style={{ fontSize: '11px', padding: '6px', color: '#2c3e50' }}>
                          <input
                            type="number"
                            value={(isNaN(item.singlediscount) || item.singlediscount === "") ? '0' : item.singlediscount}
                            onChange={(e) => handleDiscountChange(e, index)}
                            className="w-full px-2 py-1 border rounded text-sm"
                            step="0.01"
                            min="0"
                            style={{ width: '145%', marginLeft: '-20%', fontSize: '11px' }}
                          />
                        </td>
                        <td className="px-4 py-2 border-r text-right text-sm" style={{ padding: "6px", fontSize: "11px", width: "12%", color: '#2c3e50' }}>
                          {((item.singlediscount ?? 0) === 0
                            ? item.rateperkg
                            : (item.rateperkg - item.singlediscount)
                          ).toFixed(2)}
                        </td>

                        <td className="px-4 py-2 border-r text-right text-sm" style={{ fontSize: '11px', padding: '6px', color: '#2c3e50' }}>
                          {(isNaN((item.TaxableAmount)) || ((item.TaxableAmount)) === "")
                            ? (item.TaxableAmount).toFixed(2)
                            : ((item.TaxableAmount)).toFixed(2)}

                        </td>
                        <td className="px-4 py-2 border-r text-right text-sm" style={{ fontSize: '11px', padding: '6px', color: '#2c3e50' }}>{item.GSTRate}</td>
                        <td className="px-4 py-2 border-r text-right text-sm" style={{ fontSize: '11px', padding: '6px', color: '#2c3e50' }}>{item.gstAmount.toFixed(2)}</td>
                        <td className="px-4 py-2 border-r text-right text-sm" style={{ fontSize: '11px', padding: '6px', color: '#2c3e50' }}>{((item.totalPlusGst)).toFixed(2)}</td>
                        {/* <td className="px-4 py-2 border-r text-right text-sm">
                          {(isNaN((item.rateperkg - item.singlediscount) * item.totalQuantity) || ((item.rateperkg - item.singlediscount) * item.totalQuantity) === "")
                            ? (item.rateperkg * item.totalQuantity).toFixed(2)
                            : ((item.rateperkg - item.singlediscount) * item.totalQuantity).toFixed(2)}
                        </td> */}
                        <td style={{ fontSize: '11px', padding: '6px' }}>
                          <Tooltip title="Delete">
                            <IconButton
                              onClick={() => openConfirmDialog(index)}
                              size="small"
                            >
                              <DeleteIcon style={{ color: 'violet', fontSize: '18px' }} />
                            </IconButton>
                          </Tooltip>
                        </td>
                      </tr>
                    ))}

                  </tbody>
                  <tfoot>
                    <tr>
                      <td className="px-4 py-2 border-r text-left text-sm" colSpan="2">Total</td>
                      <td className="px-4 py-2 border-r text-right text-sm">{itemList.reduce((acc, item) => acc + item.quantity, 0)}</td>
                      <td className="px-4 py-2 border-r text-right text-sm">{itemList.reduce((acc, item) => acc + item.totalQuantity, 0)}</td>
                      <td className="px-4 py-2 border-r text-right text-sm">{itemList.reduce((acc, item) => acc + item.Bundle, 0)}</td>
                      <td className="px-4 py-2 border-r text-right text-sm">{itemList.reduce((acc, item) => acc + item.Pieces, 0)}</td>
                      <td className="px-4 py-2 border-r text-right text-sm"></td>
                      {/* <td className="px-4 py-2 border-r text-right text-sm">
           
              {itemList.reduce((acc, item) => {
                // Convert item.rateperkg to a number; use 0 if it's not a valid number
                const ratePerKg = Number(item.rateperkg);
                if (!isNaN(ratePerKg)) {
                  return acc + ratePerKg;
                }
                return acc; // Default to acc if ratePerKg is NaN or undefined
              }, 0).toFixed(2)}
            </td> */}


                      {/* <td className="px-4 py-2 border-r text-right text-sm">{itemList.reduce((acc, item) => acc + item.singlediscount, 0).toFixed(2)}</td>
            <td className="px-4 py-2 border-r text-right text-sm">{itemList.reduce((acc, item) => acc + (item.rateperkg - item.singlediscount), 0).toFixed(2)}</td> */}


                      <td className="px-4 py-2 border-r text-right text-sm">
                        {itemList.reduce((acc, item) => {
                          // Ensure item.singlediscount is a number, defaulting to 0 if not
                          const singleDiscount = Number(item.singlediscount) || 0;
                          return acc + singleDiscount;
                        }, 0).toFixed(2)}
                      </td>
                      <td className="px-4 py-2 border-r text-right text-sm">
                        {itemList.reduce((acc, item) => {
                          // Ensure both item.rateperkg and item.singlediscount are numbers
                          const ratePerKg = Number(item.rateperkg) || 0;
                          const singleDiscount = Number(item.singlediscount) || 0;

                          // Perform calculation only if both are valid numbers
                          if (!isNaN(ratePerKg) && !isNaN(singleDiscount)) {
                            return acc + (ratePerKg - singleDiscount);
                          } else {
                            return acc; // Return acc if any value is NaN
                          }
                        }, 0).toFixed(2)}
                      </td>

                      <td className="px-4 py-2 border-r text-right text-sm">{itemList.reduce((acc, item) => acc + item.TaxableAmount, 0).toFixed(2)}</td>
                      <td className="px-4 py-2 border-r text-right text-sm"></td>
                      <td className="px-4 py-2 border-r text-right text-sm">{itemList.reduce((acc, item) => acc + item.gstAmount, 0).toFixed(2)}</td>
                      <td className="px-4 py-2 border-r text-right text-sm">{itemList.reduce((acc, item) => acc + item.totalPlusGst, 0).toFixed(2)}</td>
                      <td className="px-4 py-2 border-r text-right text-sm"></td>
                    </tr>
                  </tfoot>
                </table>
                <Dialog
                  open={confirmDialogOpen}
                  onClose={closeConfirmDialog}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                >
                  <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                  <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                      Are you sure you want to delete this record?
                    </DialogContentText>
                  </DialogContent>

                  <DialogActions>
                    <button
                      onClick={closeConfirmDialog}
                      style={{
                        backgroundColor: '#dc3545',
                        color: '#ffffff',
                        border: '1px solid #dc3545',
                        borderRadius: '4px',
                        padding: '8px 16px',
                        cursor: 'pointer',
                        marginRight: '8px',
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      onClick={() => handleDelete(itemToDeleteIndex)}
                      style={{
                        backgroundColor: '#28a745',
                        color: '#ffffff',
                        border: '1px solid #28a745',
                        borderRadius: '4px',
                        padding: '8px 16px',
                        cursor: 'pointer',
                      }}
                    >
                      Confirm
                    </button>
                  </DialogActions>

                </Dialog>
              </TableContainer>

            </div>
          </div>


        </form >
      </div >
    </div >
  );
};

export default Extraloading;
